module.exports = __webpack_public_path__ + "img/offer.28a2ebaf.png";